export function HPriorityBankingIcon({
  className,
}: {
  className?: string;
}): JSX.Element {
  return (
    <svg
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M4.52843 21.2742V9.69217H5.5541V21.2742H4.52843ZM11.2104 21.2742V9.69217H12.2361V21.2742H11.2104ZM0.384766 24.6588V23.6332H22.9488V24.6588H0.384766ZM17.7794 21.2742V9.69217H18.8051V21.2742H17.7794ZM0.384766 7.33317V6.61783L11.6668 0.8125L22.9488 6.61783V7.33317H0.384766ZM3.2361 6.3075H20.0974L11.6668 1.9845L3.2361 6.3075Z" />
    </svg>
  );
}
